import React from 'react';
import { Divider } from '@mui/material';

interface DividerProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  textAlign?: 'center' | 'left' | 'right';
  variant?: 'fullWidth' | 'inset' | 'middle';
  absolute?: boolean;
  flexItem?: boolean;
}

const CustomDivider: React.FC<DividerProps> = ({
  className,
  orientation = 'horizontal',
  textAlign = 'center',
  variant = 'fullWidth',
  absolute = false,
  flexItem = false,
  ...props
}) => {
  return (
    <Divider
      className={className}
      orientation={orientation}
      textAlign={textAlign}
      variant={variant}
      absolute={absolute}
      flexItem={flexItem}
      {...props}
    />
  );
};

export default CustomDivider;
